/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Label } from "./Label";
import { LabelFromJSON, LabelFromJSONTyped, LabelToJSON } from "./Label";

export interface LabelDataResponse {
  data: Label;
}

export function LabelDataResponseFromJSON(json: any): LabelDataResponse {
  return LabelDataResponseFromJSONTyped(json);
}

export function LabelDataResponseFromJSONTyped(json: any): LabelDataResponse {
  if (json == null) {
    return json;
  }

  return {
    data: LabelFromJSON(json["data"]),
  };
}

export function LabelDataResponseToJSON(
  value: LabelDataResponse | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: LabelToJSON(value.data),
  };
}
